// Centralized handler for tel: / sms: links so desktop browsers always
// give the user the number (via toast + clipboard) while mobile devices
// still launch the native dialer / SMS app.
import { toast } from "sonner";
import { COMPANY } from "@/lib/api";

const isMobile = () =>
  typeof navigator !== "undefined" &&
  /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || "");

async function copyToClipboard(text) {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (_) { /* fall through */ }
  // Legacy fallback
  try {
    const ta = document.createElement("textarea");
    ta.value = text;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    document.execCommand("copy");
    document.body.removeChild(ta);
    return true;
  } catch (_) {
    return false;
  }
}

export function onCallClick(e) {
  // Let mobile devices use the native dialer.
  if (isMobile()) return;
  // On desktop: prevent the dead tel: link and give the user something useful.
  if (e?.preventDefault) e.preventDefault();
  copyToClipboard(COMPANY.phone).then((ok) => {
    toast.success(`Call ${COMPANY.phone}`, {
      description: ok ? "Number copied to clipboard." : "Tap to dial from your phone.",
      duration: 6000,
    });
  });
}

export function onTextClick(e) {
  if (isMobile()) return;
  if (e?.preventDefault) e.preventDefault();
  copyToClipboard(COMPANY.phone).then((ok) => {
    toast.success(`Text ${COMPANY.phone}`, {
      description: ok ? "Number copied — paste it into your messaging app." : "Send a text from your phone to this number.",
      duration: 6000,
    });
  });
}
